const { jsonRequest, request } = require("../../rest/index");
const CountriesModel = require("../../models/eagle/CountriesModel");
const CurrenciesModel = require("../../models/eagle/CurrenciesModel");

// Timeout constants
const PRODUCT_TIMEOUT_MS = 30000; // 30 seconds for individual product/variant requests
const PRODUCTS_TIMEOUT_MS = 20000; // 20 seconds for products list requests

const formatCountryOptions = (countryModel) => ({
  user_locale: countryModel.locale,
  user_country_iso: countryModel.iso.toUpperCase(),
  user_currency: countryModel.currency.toUpperCase(),
});

let baseUrl = "";
const setBaseUrl = (value) => {
  baseUrl = value;
};

const health = () => {
  return request.get(`${baseUrl}/health`);
};

const countries = () => {
  return request
    .get(`${baseUrl}/website/v1/countries`)
    .then((response) =>
      new CountriesModel().deserialise(response.body.data).toJSON()
    );
};

const currencies = () => {
  return request
    .get(`${baseUrl}/website/v1/currencies`)
    .then((response) => new CurrenciesModel().deserialise(response.body.data));
};

const paymentMethods = (countryModel) => {
  return request
    .get(
      `${baseUrl}/website/v2/payment_methods`,
      formatCountryOptions(countryModel)
    )
    .then((response) => response.body.data);
};

const product = (countryModel, productId) => {
  return request
    .get(
      `${baseUrl}/website/v2/products/${productId}`,
      formatCountryOptions(countryModel),
      {
        timeout: PRODUCT_TIMEOUT_MS,
      }
    )
    .then((response) => {
      const product = response.body.data;

      // Sometimes a product is not available so it returns an empty hash.
      // we check if there's a property first before getting the canvas sizes.
      // TODO eagle should probably not return an empty hash if there's a missing
      // product.
      return {
        ...product,
        dimensions: {
          width:
            product.properties && product.properties["canvas-preview-width"],
          height:
            product.properties && product.properties["canvas-preview-height"],
        },
      };
    });
};

const variant = (countryModel, variantSku) => {
  return request
    .get(
      `${baseUrl}/website/v2/variants/${variantSku}`,
      formatCountryOptions(countryModel),
      {
        timeout: PRODUCT_TIMEOUT_MS,
      }
    )
    .then((response) => {
      const variant = response.body.data;
      return {
        ...variant,
      };
    });
};

/**
 * @param {CountryModel} countryModel
 * @returns {Promise}
 */
const products = (countryModel) => {
  return request
    .get(`${baseUrl}/website/v2/products`, formatCountryOptions(countryModel), {
      timeout: PRODUCTS_TIMEOUT_MS,
    })
    .then((response) => response.body.data);
};

const shippingEstimates = (countryModel) => {
  return request
    .get(`${baseUrl}/website/v2/shipping/estimate`, {
      country_iso: countryModel.iso.toUpperCase(),
    })
    .then((response) => response.body.data);
};

const cart = async (headers) => {
  return request
    .get(`${baseUrl}/website/v2/cart`, null, { headers, redirect: "error" })
    .then((response) => response.body);
};

const updateItems = async (itemId, payload, headers) => {
  return jsonRequest
    .patch(`${baseUrl}/website/v2/cart/items/${itemId}`, payload, {
      headers,
      redirect: "error",
    })
    .then((response) => response.body);
};

const addItem = async (payload, headers) => {
  return jsonRequest
    .post(`${baseUrl}/website/v2/cart/items`, payload, {
      headers,
      redirect: "error",
    })
    .then((response) => response.body);
};

const deleteItem = async (itemId, payload, headers) => {
  return jsonRequest
    .del(`${baseUrl}/website/v2/cart/items/${itemId}`, payload, {
      headers,
      redirect: "error",
    })
    .then((response) => response.body);
};

const addPromoCode = async (payload, headers) => {
  return jsonRequest
    .post(`${baseUrl}/website/v2/cart/promotion`, payload, {
      headers,
      redirect: "error",
    })
    .then((response) => response.body);
};

const removePromoCode = async (payload, headers) => {
  return jsonRequest
    .del(`${baseUrl}/website/v2/cart/promotion`, payload, {
      headers,
      redirect: "error",
    })
    .then((response) => response.body);
};

module.exports = {
  setBaseUrl,
  health,
  countries,
  currencies,
  paymentMethods,
  products,
  product,
  variant,
  shippingEstimates,
  cart,
  updateItems,
  deleteItem,
  addItem,
  addPromoCode,
  removePromoCode,
};
